import { render, staticRenderFns } from "./DetectionPieChart.vue?vue&type=template&id=9544d32c&scoped=true"
import script from "./DetectionPieChart.vue?vue&type=script&lang=js"
export * from "./DetectionPieChart.vue?vue&type=script&lang=js"
import style0 from "./DetectionPieChart.vue?vue&type=style&index=0&id=9544d32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9544d32c",
  null
  
)

export default component.exports